/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon20Light = forwardRef('GovKoFssIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 .5a.5.5 0 0 0-1 0v1.515a8 8 0 0 0 0 15.97V19.5a.5.5 0 0 0 1 0v-1.515a8 8 0 0 0 0-15.97V.5ZM9 3.018a7 7 0 0 0 0 13.964v-1.505A5.5 5.5 0 0 1 9 4.523V3.018Zm0 2.51a4.5 4.5 0 0 0 0 8.944V12.96a3.002 3.002 0 0 1 0-5.92V5.528Zm0 2.534a2.002 2.002 0 0 0 0 3.876V8.062Zm1 8.92V3.018a7 7 0 0 1 0 13.964Z" })));
});
